import { BoxCutBase } from '../../../components/boxCut'

export class BoxCutCustom extends BoxCutBase {
  cssType!: 'default'
  protected initPC(): this {
    this['--box-cut-width'] = 'fit-content'
    this['--box-cut-height'] = 'fit-content'
    this['--box-cut-border-radius'] = '0.1rem'
    this['--box-cut-border-width'] = '1px'
    this['--box-cut-border-color'] = 'var(--theme-game-lobby-border)'
    this['--box-cut-box-shadow'] = 'var(--theme-aside-no-active-box-shadow)'
    return this
  }
  protected initH5(): this {
    this['--box-cut-width'] = 'fit-content'
    this['--box-cut-height'] = 'fit-content'
    this['--box-cut-border-radius'] = '0.2rem'
    this['--box-cut-border-width'] = '1px'
    this['--box-cut-border-color'] = 'var(--theme-game-lobby-border)'
    this['--box-cut-box-shadow'] = 'var(--theme-aside-no-active-box-shadow)'
    return this
  }
}
